import { gql, useMutation } from '@apollo/client';

import { GET_SUBSIDIARY_COMPANIES_BY_PARENT } from 'src/hooks/companies/get-subsidiary-companies.hook';
import { GET_CURRENT_COMPANY } from 'src/hooks/companies/get-current-company.hook';

export const UPDATE_COMPANY_DATEV = gql`
  mutation updateCompanyDatevNumber($datevNumberId: ObjectId!, $companyId: ObjectId!) {
    updateCompanyDatevNumber(datevNumberId: $datevNumberId, companyId: $companyId) {
      _id
    }
  }
`;

export const useUpdateCompanyDatevNumber = () => {
  const [updateCompanyDatevNumber] = useMutation(UPDATE_COMPANY_DATEV, {
    refetchQueries: [GET_SUBSIDIARY_COMPANIES_BY_PARENT, GET_CURRENT_COMPANY, GET_CURRENT_COMPANY],
  });

  return updateCompanyDatevNumber;
};
